import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { applySeo } from "@/lib/seo";
import { LeftSidebar } from "@/components/LeftSidebar";
import { TopNavbar } from "@/components/TopNavbar";
import { Footer } from "@/components/Footer";

/**
 * Gemeinsames Gerüst aller Seiten: Grain-Overlay, linke Abschnittsnavigation,
 * Kopfzeile und Footer. `sidebarItems` muss eine stabile Referenz sein
 * (Modul-Konstante), damit der Observer nicht bei jedem Render neu bindet.
 */
export const PageLayout = ({
  sidebarItems = [],
  title,
  testId = "page-main",
  children,
}) => {
  const { pathname } = useLocation();

  // Titel, Beschreibung, Canonical und Indexierung aus src/lib/seo.json.
  // `title` bleibt als Kurzname der Seite für die Lesbarkeit im Code.
  useEffect(() => {
    applySeo(pathname);
  }, [pathname]);

  return (
    <div className="relative min-h-screen bg-navy-950 text-white antialiased">
      <div className="grain-overlay" aria-hidden="true" />
      <LeftSidebar items={sidebarItems} />
      <TopNavbar />

      {/* Die Abstände der Seitenköpfe rechnen mit der 80px hohen
          Navigation. Die Startleiste darüber gleicht dieser Innenabstand aus. */}
      <main data-testid={testId} className="md:ml-20 pt-bar">
        {children}
        <Footer />
      </main>
    </div>
  );
};
